package one.healthium.content.navigation.shopping_list

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.insights.domain.models.ShoppingListModel

class DefaultShoppingListComponent(
    componentContext: ComponentContext,
    override val shoppingList: ShoppingListModel,
    private val onBackClicked: () -> Unit,
) : ShoppingListComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}